import { useState,useEffect } from "react";
import AxiosFetchData from "../pages/AxiosFetchData";
import { useNavigate, useParams } from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import axios from "axios";
import { apiUrl } from "../pages/UrlParam";
import { CatchWrapperAsync } from "../utils/catchwrapper";

export const useRolePolicies = () =>{
    const Navigate = useNavigate();
    const [token, setToken] = useState('');
    const [rowsUnits, setRowsUnits] = useState([]);
    const [selectedOptionRoles, setSelectedOptionRoles] = useState(null);
  
    const [message, setmessage] = useState('');
    const [tipe, setTipe] = useState('');
    const [role, setRole] = useState('');
    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

    useEffect(() => {
        if(selectedOptionRoles != null || selectedOptionRoles != ''){
            
            GetMenu(0);
        }
         
      },[]);

    const GetMenu = async (roleId) => {
        const fetchData = async () => {
            CatchWrapperAsync(async ()=>{
                const response = await AxiosFetchData.get(`RoleAccessList/${roleId}`).refreshToken(Navigate,"role",true);
                setRowsUnits(response.data);
                setRole(response.decode.role)
                if(response.decode.role != "SUPERADMIN"){
                  Navigate('/NOTFOUND');
                }
            },setmessage,setTipe)
        };
        
        fetchData();
      };

      
    const handleRolesAction =  async (isSelected, id, action) => {
     
        if(isSelected){
             
            isSelected = false;
        }else{
           // setSelectedAction(true);
            isSelected = true;
        }
       
        if(selectedOptionRoles === null || selectedOptionRoles.length === ''){
            setmessage("role belum dipilih");
            setTipe("error")
            return;
        }
       
         await updateRolesAction(id,isSelected,action);
         
    };

    const  updateRolesAction = async (id,selectedAction,action) =>{
        CatchWrapperAsync(async () => {
            const formData={
                name: id,
                role_id: selectedOptionRoles,
                action : action,
                selected : selectedAction
             };
           
            const response = await axios.post(`${apiUrl}/api/UpdateGroupPolicies`,formData ,{
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
          
            if(response!=null){
              
                await GetMenu(selectedOptionRoles);
                 
            }
        },setmessage,setTipe)
    }

      const ChangeRoles = async (option) => {
        setSelectedOptionRoles(option == null ? null : option.value);
        GetMenu(option == null ? null : option.value);
     };

     const columns = [
         { field: 'rowNumber', headerName: 'No.', width: 50 },
         { field: 'alias', headerName: 'Module', width: 250 },
      
       {
         field: 'actions1',
         headerName: 'READ',
         width: 150,
         renderCell: (params) => (
         <>
        
         {params.row.READ != '' && (
              
              <Checkbox {...label}  checked={params.row.IsRead == 1? true:false} onClick={async () =>await  handleRolesAction(params.row.IsRead == 1? true:false, params.row.name,"READ")} />
             // <input type="checkbox" className='edit-button'  checked={params.row.IsRead == 1? true:false} onChange={() => handleRolesAction(params.row.name,"","read")}></input>
         )}
           
         </>
         ),
       
       },
       {
         field: 'actions2',
         headerName: 'CREATE',
         width: 150,
         renderCell: (params) => (
         <>
          {params.row.CREATE != '' &&   (
              <Checkbox {...label}  id={params.row.name} checked= {params.row.IsCreate == 1? true:false} onClick={ async () => await handleRolesAction(params.row.IsCreate == 1? true:false,params.row.name,"CREATE")} />
          
         )}
           </>
         ),
       
       },
       {
         field: 'actions3',
         headerName: 'UPDATE',
         width: 150,
         renderCell: (params) => (
         <>
           {params.row.UPDATE != '' && (
             <Checkbox {...label}  checked={params.row.IsUpdate == 1 ? true: false} onClick={async () =>await handleRolesAction(params.row.IsUpdate == 1 ? true: false,params.row.name,"UPDATE")} />
           
         )}
           </>
         ),
       
       
         
       },
       {
         field: 'actions4',
         headerName: 'DELETE',
         width: 150,
         renderCell: (params) => (
           <>
           
           {params.row.DELETE != '' && (
              <Checkbox {...label}  checked= { params.row.IsDelete == 1? true:false} onClick={async() =>await handleRolesAction(params.row.IsDelete == 1? true:false,params.row.name, "DELETE")} />
            
         )}
            </>
         ),
       
       
         
       },
       
       ];
      
       const filter = (item) => item.kode.toUpperCase() !='SUPERADMIN';

       return {rowsUnits,message,tipe,role,columns,filter, ChangeRoles, selectedOptionRoles,setTipe,setmessage}
}